var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "table",
        {
          staticClass: "hidetable",
          staticStyle: {
            "table-layout": "fixed",
            display: "table",
            float: "left"
          }
        },
        [
          _c("tr", [
            _c(
              "td",
              {
                staticClass: "hidetable",
                staticStyle: { width: "320px", "max-width": "320px" }
              },
              [
                _c(
                  "div",
                  { staticStyle: { display: "flex", "align-items": "center" } },
                  [
                    _c(
                      "span",
                      {
                        staticStyle: {
                          "margin-right": "4px",
                          "white-space": "nowrap"
                        }
                      },
                      [_vm._v("Employee")]
                    ),
                    _vm._v(" "),
                    _c("autocomplete", {
                      staticStyle: { flex: "1", "min-width": "0" },
                      attrs: {
                        id: "employeeSearch",
                        type: 28,
                        allowEmpty: true
                      },
                      on: { finish: _vm.setData },
                      model: {
                        value: _vm.employeeSearch,
                        callback: function($$v) {
                          _vm.employeeSearch = $$v
                        },
                        expression: "employeeSearch"
                      }
                    })
                  ],
                  1
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "td",
              {
                staticClass: "hidetable",
                staticStyle: { width: "430px", "max-width": "430px" }
              },
              [
                _c(
                  "div",
                  { staticStyle: { display: "flex", "align-items": "center" } },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "filter-dropdown",
                        staticStyle: { "margin-right": "10px" },
                        on: {
                          mouseenter: function($event) {
                            _vm.showFilterMenu = true
                          },
                          mouseleave: function($event) {
                            _vm.showFilterMenu = false
                          }
                        }
                      },
                      [
                        _c(
                          "button",
                          { staticStyle: { height: "30px", width: "40px" } },
                          [
                            _c("font-awesome-icon", {
                              attrs: { icon: "filter" }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.showFilterMenu
                          ? _c("div", { staticClass: "csv-menu" }, [
                              _c(
                                "div",
                                {
                                  on: {
                                    click: function($event) {
                                      return _vm.setFilter("payperiod")
                                    }
                                  }
                                },
                                [_vm._v("Pay Period")]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  on: {
                                    click: function($event) {
                                      return _vm.setFilter("week")
                                    }
                                  }
                                },
                                [_vm._v("Week")]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  on: {
                                    click: function($event) {
                                      return _vm.setFilter("custom")
                                    }
                                  }
                                },
                                [_vm._v("Custom")]
                              )
                            ])
                          : _vm._e()
                      ]
                    ),
                    _vm._v(" "),
                    _vm.filterMode === "custom"
                      ? [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.startDate,
                                expression: "startDate"
                              }
                            ],
                            staticClass: "date",
                            staticStyle: {
                              height: "25px",
                              flex: "1",
                              "min-width": "0"
                            },
                            attrs: { id: "startDate", type: "date" },
                            domProps: { value: _vm.startDate },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.startDate = $event.target.value
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("span", { staticStyle: { margin: "0 4px" } }, [
                            _vm._v("–")
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.endDate,
                                expression: "endDate"
                              }
                            ],
                            staticClass: "date",
                            staticStyle: {
                              height: "25px",
                              flex: "1",
                              "min-width": "0"
                            },
                            attrs: { id: "endDate", type: "date" },
                            domProps: { value: _vm.endDate },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.endDate = $event.target.value
                              }
                            }
                          })
                        ]
                      : _c(
                          "select",
                          {
                            staticStyle: {
                              flex: "1",
                              height: "25px",
                              "min-width": "0"
                            },
                            domProps: {
                              value: _vm.startDate + "|" + _vm.endDate
                            },
                            on: { change: _vm.onRangeSelect }
                          },
                          _vm._l(
                            _vm.filterMode === "week"
                              ? _vm.weekOptions
                              : _vm.payPeriodOptions,
                            function(opt) {
                              return _c(
                                "option",
                                {
                                  key: opt.value,
                                  domProps: { value: opt.value }
                                },
                                [_vm._v(_vm._s(opt.label))]
                              )
                            }
                          ),
                          0
                        )
                  ],
                  2
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "td",
              {
                staticClass: "hidetable",
                staticStyle: { width: "100px", "white-space": "nowrap" }
              },
              [
                _c(
                  "button",
                  {
                    staticStyle: { height: "30px", width: "40px" },
                    on: {
                      click: function($event) {
                        return _vm.search()
                      }
                    }
                  },
                  [_c("font-awesome-icon", { attrs: { icon: "search" } })],
                  1
                ),
                _vm._v(" "),
                _c("span", [_vm._v("Search")])
              ]
            ),
            _vm._v(" "),
            _c(
              "td",
              {
                staticClass: "hidetable",
                staticStyle: { width: "100px", "white-space": "nowrap" }
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "csv-dropdown",
                    on: {
                      mouseenter: function($event) {
                        _vm.showCsvMenu = true
                      },
                      mouseleave: function($event) {
                        _vm.showCsvMenu = false
                      }
                    }
                  },
                  [
                    _c(
                      "button",
                      { staticStyle: { height: "30px", width: "40px" } },
                      [
                        _c("font-awesome-icon", { attrs: { icon: "download" } })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("span", [_vm._v("Download CSV")]),
                    _vm._v(" "),
                    _vm.showCsvMenu
                      ? _c("div", { staticClass: "csv-menu" }, [
                          _c(
                            "div",
                            {
                              on: {
                                click: function($event) {
                                  return _vm.download("payperiod")
                                }
                              }
                            },
                            [_vm._v("Pay Period")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              on: {
                                click: function($event) {
                                  return _vm.download("timesheet")
                                }
                              }
                            },
                            [_vm._v("Timesheet")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              on: {
                                click: function($event) {
                                  return _vm.download("extra")
                                }
                              }
                            },
                            [_vm._v("Extra")]
                          )
                        ])
                      : _vm._e()
                  ]
                )
              ]
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c("layout-7", {
        ref: "layout7",
        staticStyle: { width: "100%", height: "calc(100vh - 100px)" },
        attrs: {
          id: _vm.pageid,
          term: _vm.searchTerm,
          edit_types: [
            null,
            null,
            null,
            "DateTime",
            "DateTime",
            null,
            "TextArea",
            "Value",
            "Value",
            null
          ],
          edit_perm: "99",
          isSelect: true
        },
        on: { select: _vm.onSelect }
      }),
      _vm._v(" "),
      _vm.selectedTimesheetId !== null
        ? _c("div", { staticClass: "ts-overlay" }, [
            _c(
              "div",
              { staticClass: "ts-popup" },
              [
                _c(
                  "button",
                  {
                    staticClass: "ts-close",
                    on: {
                      click: function($event) {
                        _vm.selectedTimesheetId = null
                      }
                    }
                  },
                  [_c("font-awesome-icon", { attrs: { icon: "times" } })],
                  1
                ),
                _vm._v(" "),
                _c("timesheet-history", {
                  attrs: {
                    term: _vm.selectedTimesheetId,
                    employeeid: _vm.selectedTimesheetData[0],
                    fromdatetime: _vm.selectedTimesheetData[1],
                    todatetime: _vm.selectedTimesheetData[2]
                  }
                })
              ],
              1
            )
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4a6dfb2a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a6dfb2a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/view/Timesheets.vue
// module id = 582
// module chunks = 0